import { newRequestId } from './model'

// Retain an uncertain POST across closing/reopening the modal in this session.
// A retry of the transport must use the original body, including its version.
const requests = new Map()

export function pendingRequest(operationId) {
  return requests.get(operationId) || null
}

export function prepareRequest(operation, action) {
  if (!requests.has(operation.id)) requests.set(operation.id, {
    action, body: { request_id: newRequestId(), expected_version: operation.version }
  })
  return requests.get(operation.id)
}

export function finishRequest(operationId, request) {
  if (requests.get(operationId) === request) requests.delete(operationId)
}
